import logo from "../assets/speak-schedule-blue-logo.png";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full px-4">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={logo} alt="image" className="w-16 h-16 rounded-lg" />
        <h1 className="mt-2 text-4xl font-bold">
          Privacy Policy: How SPEAK Schedule Protects Your Information
        </h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2025-01-23
        </p>
        <div className="details mt-4">
          <p>
            This Privacy Policy ("Policy") describes how SPEAK Schedule ("we,"
            "us," or "our") collects, uses, and discloses your information when
            you use our mobile application ("App").
          </p>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Information We Collect</h1>
            <div className="subsec ml-5 mt-2">
              <h3 className="text-xl font-bold">
                Information You Provide Directly:
              </h3>
              <ul className="list-disc list-outside mt-1">
                <li>
                  <strong>Account Information:</strong> When you create an
                  account, you may provide certain personally identifiable
                  information ("PII") such as your name, email address, and
                  password.
                </li>
                <li className="mt-1">
                  <strong>Event and Reminder Details:</strong> The information
                  you enter into the App for scheduling events and setting
                  reminders. We do not store the actual event details or
                  reminders after they have been processed.
                </li>
              </ul>
            </div>
            <div className="subsec ml-5 mt-4">
              <h3 className="text-xl font-bold">
                Information Collected Automatically:
              </h3>
              <ul className="list-disc list-outside mt-1">
                <li>
                  <strong>Usage Data:</strong> We collect information about your
                  activity within the App, such as the features you use and the
                  time of your usage.
                </li>
                <li className="mt-1">
                  <strong>Device Information:</strong> We collect information
                  about the device you use to access the App, such as your
                  device type, operating system, and unique device identifier.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Use of Your Information</h1>
            <ul className="list-disc list-outside ml-5 mt-2">
              <li>To provide and operate the SPEAK Schedule.</li>
              <li>To improve and personalize your experience.</li>
              <li>To develop new features.</li>
              <li>To provide customer support.</li>
              <li>
                To send you marketing and promotional communications (with your
                consent).
              </li>
              <li>To analyze how the SPEAK Schedule is used.</li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              Free Trial and Paid Subscriptions
            </h1>
            <p className="mt-1">
              SPEAK Schedule offers a free trial period. To access the full
              features after the trial, you must subscribe to a paid plan. We
              may use your payment information to process your subscription and
              may store it for future purchases.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Sharing of Your Information</h1>
            <p className="mt-1">
              We may share your information with third-party service providers
              who help us operate and improve the SPEAK Schedule. These service
              providers are contractually obligated to keep your information
              confidential and secure. We will not share your PII with any third
              party for marketing purposes without your consent.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Data Retention</h1>
            <p className="mt-1">
              We will retain your information for as long as your account is
              active or as needed to provide you with the services you request.
              We may also retain your information for legal or compliance
              reasons.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Security</h1>
            <p className="mt-1">
              We take reasonable measures to protect your information from
              unauthorized access, disclosure, alteration, or destruction.
              However, no Internet transmission or electronic storage method is
              100% secure.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Your Choices</h1>
            <p className="mt-1">
              You can access and update your account information at any time.
              You can also unsubscribe from marketing communications by
              following the instructions in those communications.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Children's Privacy</h1>
            <p className="mt-1">
              Our App is not directed to children under the age of 13. We do not
              knowingly collect information from children under 13. If you are a
              parent or guardian and you believe your child has provided us with
              information, please contact us.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Changes to This Policy</h1>
            <p className="mt-1">
              We may update this Policy from time to time. We will notify you of
              any changes by posting the new Policy on this page.
            </p>
          </div>
        </div>
      </div>

      <footer className="w-full mt-10 py-4 bg-neutral-100 text-center">
        <h1>
          All Rights Reserved{" "}
          <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
        </h1>
      </footer>
    </div>
  );
}
